import { render, staticRenderFns } from "./InputImageUpload.vue?vue&type=template&id=20069ce4"
import script from "./InputImageUpload.vue?vue&type=script&lang=js"
export * from "./InputImageUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports